module.exports = __webpack_public_path__ + "img/S0.da283dec.png";